






































































import * as resourceAPI from '@adobe/edex/frontend/api/resource';
import { mapState } from 'vuex';
import { paginateMixin } from '@adobe/edex/frontend/mixins/paginate';
import Ratings from '@adobe/edex/frontend/components/common/ratings.vue';
import {
  ResourceBuilderPath,
  RoutePath,
} from '@adobe/edex/ui/shared/constants';

export default {
  props: ['profile'],
  components: { Ratings },
  mixins: [paginateMixin],
  data() {
    return {
      resources: null,
      newTeachingResourcePath: ResourceBuilderPath.new
    };
  },
  async created() {
    await this.list();
  },
  computed: {
    ...mapState('member', ['member']),
    showMore() {
      return this.resources?.meta.hasMore;
    },
    canEdit() {
      return this.profile.id === this.member?.id;
    },
  },
  methods: {
    list() {
      this.paginate({
        api: resourceAPI.listPublished,
        name: 'resources',
        params: {
          limit: 5,
          createdBy: this.profile.id,
        },
      });
    },
    onMore() {
      this.list();
    },
    getHref(resource) {
      return this.buildLink(
        `${RoutePath.teachingResources}/${resource.vanityURL}`
      );
    },
  },
};
